import cn from 'classnames';

import OPE from 'js/on-page-editing';
import { defineTheme, hasTheme, type ThemeKeys } from 'js/utils/theme-helpers';

import Link, { type LinkTheme } from 'components/link/Link';
import NestedLink from 'components/nested-link/NestedLink';

import { ILinkList } from 'source/NFR.types';

const themes = defineTheme({
  border: 'link-list--theme-border',
  portfolio: 'link-list--theme-portfolio',
  frontpageLinks: 'link-list--theme-frontpage-links'
});
type Theme = ThemeKeys<typeof themes>;

interface LinkListProps extends ILinkList {
  className?: string;
  linkTheme?: LinkTheme | LinkTheme[];
  theme?: Theme;
  withIcon?: boolean;
}

const LinkList: React.FC<LinkListProps> = ({
  className,
  items = [],
  nestedLinks,
  linkTheme = [],
  onPageEditing,
  theme,
  withIcon
}) => {
  const isPortfolio = hasTheme<LinkTheme>(linkTheme, 'portfolio');

  return (
    <ul
      className={cn('link-list', className, themes(theme), {
        'link-list--with-icon': withIcon && !isPortfolio
      })}
      {...OPE(onPageEditing?.items)}
    >
      {nestedLinks?.map((nestedLink, index) => (
        <NestedLink key={nestedLink.url + String(index)} {...{ item: nestedLink, linkTheme }} />
      ))}
      {items?.map((link, index) => (
        <li
          className={cn('link-list--link', {
            'link-list--link--theme-large': hasTheme<LinkTheme>(linkTheme, 'large')
          })}
          key={link.url + String(index)}
        >
          <Link theme={linkTheme} {...link} />
        </li>
      ))}
    </ul>
  );
};

LinkList.displayName = 'LinkList';

export default LinkList;
